import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

const FORMATS: Record<IntakeDateFormat, Intl.DateTimeFormatOptions> = {
  day: { day: 'numeric', month: 'short' },
  dayYear: { day: 'numeric', month: 'short', year: 'numeric' },
  dayTime: { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' },
};
export type IntakeDateFormat = 'day' | 'dayYear' | 'dayTime';

const ISO_DAY = /^(\d{4})-(\d{2})-(\d{2})$/;

/**
 * Dates in the active language. The app registers no Angular locale data, so DatePipe is
 * en-US everywhere; Intl knows nl without it. Impure: the language can change after render.
 */
@Pipe({ name: 'intakeDate', pure: false, standalone: false })
export class IntakeDatePipe implements PipeTransform {
  private formatters = new Map<string, Intl.DateTimeFormat>();

  constructor(private translate: TranslateService) {}

  transform(value: string | Date | null | undefined, format: IntakeDateFormat): string {
    if (!value) { return ''; }
    const day = typeof value === 'string' ? ISO_DAY.exec(value) : null;
    const date = day ? new Date(+day[1], +day[2] - 1, +day[3]) : new Date(value);
    if (isNaN(date.getTime())) { return ''; }
    const lang = this.translate.currentLang || this.translate.defaultLang || 'en';
    // Plain en is en-US in Intl ("Oct 22, 2026"); en-GB keeps the day-first form used so far.
    const key = `${lang}|${format}`;
    if (!this.formatters.has(key)) { this.formatters.set(key, new Intl.DateTimeFormat(lang === 'en' ? 'en-GB' : lang, FORMATS[format])); }
    return this.formatters.get(key).format(date);
  }
}
